import { Injectable, inject, NgZone } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { RoutePointType } from './routing.models';

export interface RouteEventData {
  routeType: RoutePointType;
  position: { x: number; y: number; z: number };
}

@Injectable({ providedIn: 'root' })
export class RouteEventService {
  private ngZone = inject(NgZone);

  private routeEventSubject = new Subject<RouteEventData>();

  readonly routeEvent$: Observable<RouteEventData> = this.routeEventSubject.asObservable();

  emitRouteEvent(data: RouteEventData): void {
    this.ngZone.run(() => {
      this.routeEventSubject.next(data);
    });
  }
}
